import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import MyEventSkeleton from "../../../components/skeleton/my/myEventSkeleton";
import { getAllByIsShowIsTrue } from "../../../service";
import { TopBar } from "../../../widgets";
import dayjs from "dayjs";

const Event = () => {
    const [eventList, setEventList] = useState<IEventBoard[]>([]);
    const [isInitLoading, setIsInitLoading] = useState<boolean>(true);
    const navigate = useNavigate();

    useEffect(() => {
        getAllByIsShowIsTrue()
            .then(res => { setEventList(res.data.sort((a, b) => dayjs(b.createdDate).diff(dayjs(a.createdDate)))) })
            .catch(err => console.error(err))
            .finally(() => setIsInitLoading(false))
    }, [])

    return <>
        {isInitLoading
            ? <MyEventSkeleton />
            : <>
                <TopBar title="이벤트" rightIcon={false} position='fixed' thema='dark' />
                <div style={{ padding: "32px 20px", display: "flex", flexDirection: "column", gap: "32px" }}>
                    {(eventList?.length ?? 0) > 0 && eventList?.filter((e) => e.isShow).map(event =>
                        <div key={event.id} style={{ display: "flex", flexDirection: "column", gap: "16px", cursor: 'pointer' }} onClick={() => navigate(`/event/${event.id ?? 1}`)}>
                            {event?.thumbnailImgUrl && <img alt="event" style={{ borderRadius: "4px", aspectRatio: "1005/600", objectFit: "cover" }} src={event?.thumbnailImgUrl} width="100%" />}
                            <div>
                                <div className="sub-title/st3 base/black">
                                    {event.title}
                                </div>
                                <div style={{ color: "#7D7D7D", fontSize: "12px", height: "20px", lineHeight: "20px" }}>
                                    {event?.startDate ? event?.startDate?.slice(0, 10)?.replaceAll("-", ". ") : "2024-04-02T13:00:00"?.slice(0, 10)?.replaceAll("-", ". ")} - {event?.endDate ? event?.endDate?.slice(0, 10)?.replaceAll("-", ". ") : "이벤트 종료 시"}
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </>}
    </>
}

export default Event;